import {Model} from "@/app/Model";

export class FamigliaPercorsoFlow {
    
	public oggetto_di_giudizio:string = "";

	public tipologia_procedimento:string = "";
	public addebito:string = "";
	public motivi_addebito_separazione:string = "";

	public figli:boolean = false;
	public regime_affidamento:string = "";
	public regime_collocamento:string = "";
	public regime_mantenimento:string = "";
		 
	//---
    public paginazione_tot: number = 0;
    public paginazione_start: number = 0; //numero di pagina
    public paginazione_rows: number = Model.pagination_size;
    public paginazione_pages: number = 0;

	public diritto_paginazione_tot: number = 0;
	public diritto_paginazione_start: number = 0; //numero di pagina
	public diritto_paginazione_rows: number = Model.pagination_size;
	public diritto_paginazione_pages: number = 0;

    public reset(): void {
		this.oggetto_di_giudizio = "";
		this.tipologia_procedimento = "";
	    this.addebito = "";
	    this.motivi_addebito_separazione = "";
		this.figli = false;
		this.regime_affidamento = "";
		this.regime_collocamento = "";
		this.regime_mantenimento = "";

        this.paginazione_tot = 0;
        this.paginazione_start = 0;
        this.paginazione_rows = Model.pagination_size;
        this.paginazione_pages = 0;

		this.diritto_paginazione_tot = 0;
		this.diritto_paginazione_start = 0;
		this.diritto_paginazione_rows = Model.pagination_size;
		this.diritto_paginazione_pages = 0;

    }
}